import { render, staticRenderFns } from "./TextPatchEditor.vue?vue&type=template&id=42d6bde6&scoped=true&"
import script from "./TextPatchEditor.vue?vue&type=script&lang=js&"
export * from "./TextPatchEditor.vue?vue&type=script&lang=js&"
import style0 from "./TextPatchEditor.vue?vue&type=style&index=0&id=42d6bde6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d6bde6",
  null
  
)

export default component.exports